import { render } from "./ChainComponent.vue?vue&type=template&id=c516cf1c&scoped=true"
import script from "./ChainComponent.vue?vue&type=script&lang=js"
export * from "./ChainComponent.vue?vue&type=script&lang=js"

import "./ChainComponent.vue?vue&type=style&index=0&id=c516cf1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c516cf1c"]])

export default __exports__